import React from "react";
import styled from 'styled-components';

const Square = styled.div`
        position: absolute;
        background:${(props) => {return props.focusedPinId === props.pin.id ? '#218838' : '#00000040'}};
        height:25px;
        width:25px;
        bottom:6px;
        left:6px;
        border:3px solid #fff;
        border-radius:4px;
    `;
    const Button = styled.button`
        background:${(props) => {return props.focusedPinId === props.pin.id ? '#00000040' : 'none'}};
        border:none;
        max-width:150px;
        min-height: 69px;
        border-radius:4px;
        position:absolute;
        top: ${props => props.pin.top}%;
        left: ${props => props.pin.left}%;
        line-height:17px;
        text-align:left;
        padding-left:35px;
        padding-top: 30px;
        padding-bottom: 9px
    `; 

    const Text = styled.div`
        background: #ffffff9c;
        padding: 6px 7px;
        border-radius: 4px;
        font-size: 12px;
        line-height: 14px;
        position: relative;
        top: -19px;
        left: -7px;
    `;


function onMouseEnter(evt){
    evt.target.parentElement.classList.add("hovered");
}
function onMouseLeave(evt){
    evt.target.parentElement.classList.remove("hovered");
}

function PinMarker({focusedPinId, pin, pinClicked}){
    return (  
        <Button
            className={pin.id === focusedPinId ? 'clicked' : ''}
            onClick={()=>{pinClicked(pin.id)}} 
            focusedPinId={focusedPinId} 
            pin={pin}>
            <Text className="pinText">{pin.name}</Text>             
            <Square  
                onMouseEnter={(e)=>{onMouseEnter(e)}} 
                onMouseLeave={(e)=>{onMouseLeave(e)}}  
                focusedPinId={focusedPinId} pin={pin} />
        </Button>);
}
export default PinMarker;